// extracted by mini-css-extract-plugin
export default {"root":"_2Rg_u","popover":"_2FWUy","content":"_2VJ4x","list":"_2_6Bg","list-item":"_1HADh","listItem":"_1HADh"};